import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h4>{`Linux | Arduino | C | C++ | Java | Python | AutoCAD | MATLAB`}</h4>
    <p>{`Hey there, I am Kritika Sharma from Himachal Pradesh. I am a microcontroller enthusiast, and I've worked on automations with ESP32, and OpenCV platforms. I hold proficient hands on experience with "Electric Motors", "Electric Switchgears & Applications", and I've working experience with ECP (Electric Control Panels).
Apart from being a grand holder of Hardware Academia, I have a good grasp of the software side of this paradigm. Including crediting in several "DevConf" and derivative conferences, I am well versed with several of DevOps tools comprising Git, Docker, Kubernetes, and other cloud tools as well.
I prefer attributing to arts and reading to employ my free time.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      